import * as moment from "moment";
import { Role, Claims } from "@eave/shared/types/api/claims";
import { HLHLContactRole } from "@eave/shared/types/api";
import APIClient from "web_modules/APIClient";

export function getSessionToken(): string {
  return localStorage.getItem("eaveToken");
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return "";
}

let restricted = {};

export function saveRestrictedList(list) {
  const now = new Date();
  const fiveMin = 5 * 60 * 1000;
  now.setTime(now.getTime() + fiveMin);

  restricted = {
    expiration: now,
    restrictedApps: list,
  };
}

const getAndSaveRestrictedAppList = (): Promise<any> => {
  return APIClient.get("/uw/loan_applications/restricted").then((r: any) => {
    saveRestrictedList(r.restricted_list);
    return r.restricted_list;
  });
};

export function getRestrictedList(): any {
  return restricted;
}

export const checkAppRestricted = (appID: number): Promise<boolean> => {
  const restrictedList = getRestrictedList();
  if (restrictedList) {
    const list = restrictedList.restrictedApps;
    if (moment(restrictedList.expiration).isAfter(moment()) && list) {
      const isRestricted = list[appID];
      if (isRestricted !== undefined) {
        return Promise.resolve(isRestricted);
      }
    }
  }

  return getAndSaveRestrictedAppList().then(d => {
    return d[appID];
  });
};

export function saveSessionToken(authToken) {
  localStorage.setItem("eaveToken", authToken);
}

export function saveFileDownloadToken(fileAuthToken) {
  document.cookie = `EaveFileAuthorization=${fileAuthToken}; path=/files/`;
}

export function endSession() {
  localStorage.removeItem("eaveToken");

  // to delete a cookie, set its expiration in the past
  // cookie params must match exactly the create params (path, domain, etc)
  const yesterday = new Date();
  yesterday.setTime(yesterday.getTime() + -1 * 24 * 60 * 60 * 1000);
  document.cookie = `EaveFileAuthorization=; path=/files/; expires=${yesterday.toUTCString()}`;
}

export function tokenHasRoles(token: string, ...roles: Role[]): boolean {
  if (token) {
    const claims: Claims = JSON.parse(atob(token.split(".")[1]));

    for (let i = 0; i < roles.length; i++) {
      if (claims.roles.includes(roles[i])) {
        return true;
      }
    }
  }

  return false;
}

export function rolesFromToken(token: string): Role[] {
  if (token) {
    const claims: Claims = JSON.parse(atob(token.split(".")[1]));

    return claims.roles;
  }

  return [];
}
export function isUserAdmin(): boolean {
  return tokenHasRoles(getSessionToken(), Role.Admin, Role.OpsAdmin, Role.CashCloseAdmin);
}

export function operatorIdFromToken(token: string): number {
  if (!token) {
    return null;
  }

  const claims: Claims = JSON.parse(atob(token.split(".")[1]));
  if (claims.user_type !== "operator") {
    return null;
  }

  return claims.user_id;
}

export function operatorHLHLContactRoleFromToken(token: string): HLHLContactRole {
  if (!token) {
    return null;
  }

  const claims: Claims = JSON.parse(atob(token.split(".")[1]));
  if (!claims.hlhl_contact_role) {
    return null;
  }

  return claims.hlhl_contact_role as HLHLContactRole;
}
